// src/config.js
let config = {
  REACT_APP_WEB_LINK: '',
  REACT_APP_IMG_UPLOAD_LINK: '',
};

export const loadConfig = async () => {
  const response = await fetch('/config.json');
  const json = await response.json();
  config = json;
};

export const getConfig = () => config;
